import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Field } from 'formik';
//import { Select } from 'formik-material-ui';
import Select, { Option, ReactSelectProps } from 'react-select';
import AsyncSelect from 'react-select/async';
import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
  ListItemText,
  Checkbox,
  Input,
  Button,
} from '@material-ui/core';
import { FormatColorReset } from '@material-ui/icons';
import * as selectNameOrEmailAction from '../../../actions/selectNameOrEmail.action';
import { useDispatch, useSelector } from 'react-redux';

// const options = [
//   {
//     value: 1,
//     label: 'ข้อมูลพื้นฐานที่ระบุตัวตน เช่น ชื่อ รายละเอียดการติดต่อ',
//   },
//   { value: 2, label: 'ข้อมูลที่ระบุตัวตน เช่น Username และ Password' },
//   {
//     value: 3,
//     label: 'ข้อมูลด้านการเงิน เช่น Credit Card ID ข้อมูลสถาบันการเงิน',
//   },
//   { value: 4, label: 'ข้อมูลด้าน Biometric' },
//   { value: 5, label: 'ข้อมูลด้านสุขภาพ' },
//   { value: 6, label: 'ข้อมูลศาสนาและความเชื่อ' },
//   { value: 7, label: 'ข้อมูลเกี่ยวกับความเห็นทางการเมือง' },
//   { value: 8, label: 'ข้อมูลเกี่ยวกับเพศและเพศสภาพ' },
//   {
//     value: 9,
//     label: 'ข้อมูลส่วนบุคคลที่เป็นทางการ เช่น Passport ใบขับขี่ บัตรประชาชน',
//   },
//   { value: 10, label: 'ข้อมูลตำแหน่งสถานที่' },
//   { value: 11, label: 'ไม่สามารถระบุได้' },
//   { value: 12, label: 'อื่นๆ' },
// ];
// const personalDataCategories = [
//   'ข้อมูลพื้นฐานที่ระบุตัวตน เช่น ชื่อ รายละเอียดการติดต่อ',
//   'ข้อมูลที่ระบุตัวตน เช่น Username และ Password',
//   'ข้อมูลด้านการเงิน เช่น Credit Card ID ข้อมูลสถาบันการเงิน',
//   'ข้อมูลด้าน Biometric',
//   'ข้อมูลด้านสุขภาพ',
//   'ข้อมูลศาสนาและความเชื่อ',
//   'ข้อมูลเกี่ยวกับความเห็นทางการเมือง',
//   'ข้อมูลเกี่ยวกับเพศและเพศสภาพ',
//   'ข้อมูลส่วนบุคคลที่เป็นทางการ เช่น Passport ใบขับขี่ บัตรประชาชน',
//   'ข้อมูลตำแหน่งสถานที่',
//   'ไม่สามารถระบุได้',
//   'อื่นๆ',
// ];
// const names = [
//   'Oliver Hansen',
//   'Van Henry',
//   'April Tucker',
//   'Ralph Hubbard',
//   'Omar Alexander',
//   'Carlos Abbott',
//   'Miriam Wagner',
//   'Bradley Wilkerson',
//   'Virginia Andrews',
//   'Kelly Snyder',
// ];

// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250,
//     },
//   },
// };

const customStyles = {
  control: (provide, state) => ({
    flexDirection: 'row',
    display: 'flex',
    border: '1px solid #ccc',
    font: '1.2rem',
  }),
  valueContainer: () => ({
    flexDirection: 'row',
    margin: '5px',
    padding: '5px',
    fontSize: '1rem',
    minWidth: '90%',
  }),
  indicatorsContainer: () => ({
    flexDirection: 'row',
    display: 'flex',
    minWidth: '10%',
  }),
};
/**
 * SelectPersonalDataCategory() (component)
 * @param {string} name, name of select element (default: category_id)
 * @param {string} id, id of select element (default: category_id)
 * @param {string} label, label of select element (default: "ประเภทของข้อมูลส่วนบุคคลที่มีการละเมิด")
 * @param {function} onChange, onChange
 * @param {string|number} value, value of select element
 * @param {Formik.touched} touched
 * @param {Formik.errors} errors
 * @param {object} className, className of select element
 * @returns (element) SelectPersonalDataCategory
 */
const SelectNameOrEmail = ({
  name,
  id,
  label,
  onChange,
  value,
  touched,
  errors,
  className,
}) => {
  const dispatch = useDispatch();
  const SelectNameOrEmailReducer = useSelector(
    ({ SelectNameOrEmailReducer }) => SelectNameOrEmailReducer
  );

  const loadUserName = async (inputValue, callback) => {
    if (inputValue.length > 2) {
      callback(
        await dispatch(selectNameOrEmailAction.loadUserName(inputValue))
      );
    }
  };
 
  //const [inputValue, setValue] = useState('');
  const [selectedValue, setSelectedValue] = useState('');
  // handle input change event
  // const handleInputChange = (value) => {
  //   setValue(value);
  // };

  //Set internal value (selectedValue) when external value is changed
  // useEffect(() => {
  //   if (selectedValue.length == 3) {
  //     loadUserName();
  //   }
  // }, [selectedValue]);

  // const handleChange = (value) => {
  //   setValue(value);
  //   // console.log(value);
  //   //loadUserName(value);
  // };

  // Handle change select
  const memoHandleChange = useCallback((value) => {
    // let context = typeof c.props.children === 'string' ? c.props.children : '';
    if(value){
      value["user_id"] = value.id;
    }
    onChange && onChange([value]);
    setSelectedValue(value);
  });

  // const loadOptions = async (inputValue) => {
  //   let data = await options.find((option) => option.value == inputValue);
  //   return data ? [data] : [];
  // };

  let labelPlaceHold = 'ค้นหาผู้ใช้งาน ชื่อ หรือ นามสกุล (3 ตัวอักษร+)';

  return (
    <React.Fragment>
      <div style={{ marginButton: '5px' }}>
        <InputLabel htmlFor={id}>{labelPlaceHold}</InputLabel>
      </div>
      <FormControl
        fullWidth
        disabled={true}
        error={errors && touched ? true : false}
        className={className}
      >
        <AsyncSelect
          id={id}
          name={name}
          //cacheOptions
          defaultOptions={false}
          value={selectedValue}
          getOptionLabel={(e) => `${e.fullName} (${e.fullNameEn})`}
          getOptionValue={(e) => e.id}
          loadOptions={loadUserName}
          onInputChange={() => {
            setSelectedValue('');
          }}
          onChange={memoHandleChange}
          styles={customStyles}
          placeholder={labelPlaceHold}
          defaultValue={value}
          styles={{
            // Fixes the overlapping problem of the component
            menu: (provided) => ({ zIndex: 9999 }),
          }}
        />

        <FormHelperText>{touched && errors && errors}</FormHelperText>
      </FormControl>
    </React.Fragment>
  );
};

// Types[, Rules] of props
SelectNameOrEmail.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
};

export default React.memo(SelectNameOrEmail);
